import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import HomePage from "@/pages/HomePage";
import ScanPage from "@/pages/ScanPage";
import BrowsePage from "@/pages/BrowsePage";
import ChecklistPage from "@/pages/ChecklistPage";
import ProduksiPage from "@/pages/ProduksiPage";
import FinishingPage from "@/pages/FinishingPage";
import SiapKirimPage from "@/pages/SiapKirimPage";
import TerkirimPage from "@/pages/TerkirimPage";
import OwnerDashboardPage from "@/pages/OwnerDashboardPage";
import AdminPage from "@/pages/AdminPage";
import RoomPage from "@/pages/RoomPage";
import ProgressPage from "@/pages/ProgressPage";
import PrintPage from "@/pages/PrintPage";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/supervisor" element={<ScanPage mode="supervisor" />} />
                    <Route path="/supervisor/browse" element={<BrowsePage mode="supervisor" />} />
                    <Route path="/s/:roomId" element={<RoomPage mode="supervisor" />} />
                    <Route path="/admin" element={<ScanPage mode="admin" />} />
                    <Route path="/admin/browse" element={<BrowsePage mode="admin" />} />
                    <Route path="/admin/checklist/:dept" element={<ChecklistPage />} />
                    <Route path="/admin/produksi" element={<ProduksiPage />} />
                    <Route path="/admin/finishing" element={<FinishingPage />} />
                    <Route path="/admin/siap-kirim" element={<SiapKirimPage />} />
                    <Route path="/admin/terkirim" element={<TerkirimPage />} />
                    <Route path="/admin/owner" element={<OwnerDashboardPage />} />
                    <Route path="/a/:roomId" element={<RoomPage mode="admin" />} />
                    <Route path="/a/:roomId/progress" element={<ProgressPage mode="admin" />} />
                    <Route path="/s/:roomId/progress" element={<ProgressPage mode="supervisor" />} />
                    <Route path="/admin/dashboard" element={<AdminPage />} />
                    <Route path="/r/:roomId" element={<RoomPage />} />
                    <Route path="/print/:roomId" element={<PrintPage />} />
                </Routes>
            </BrowserRouter>
            <Toaster position="top-center" richColors />
        </div>
    );
}

export default App;
